"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo, ko*/
(function () {
  ko.components.register('kobo-loading-submit-button', {
    viewModel: function viewModel(params) {
      return new LoadingSubmitButton(params);
    },
    template: Kobo.$('#kobo-loading-submit-button-template').html()
  });
})();

var LoadingSubmitButton = /*#__PURE__*/function () {
  function LoadingSubmitButton(params) {
    _classCallCheck(this, LoadingSubmitButton);

    var name = params.name,
        isDisabled = params.isDisabled,
        formToSubmit = params.formToSubmit,
        idleText = params.idleText,
        progressText = params.progressText;
    this.name = name;
    this.formToSubmit = formToSubmit;
    this.idleText = idleText;
    this.progressText = progressText;
    this.buttonText = ko.observable(idleText);
    this.isDisabled = ko.observable(isDisabled);
    this.isLoading = ko.observable(false);
    this.setupEvents();
  }

  _createClass(LoadingSubmitButton, [{
    key: "handleLoadingEvent",
    value: function handleLoadingEvent(_, data) {
      var recipientButtonName = data.detail.recipientButtonName;
      if (recipientButtonName !== this.name) return;
      this.isDisabled(true);
      this.buttonText(this.progressText);
      this.isLoading(true);
    }
  }, {
    key: "handleLoadedEvent",
    value: function handleLoadedEvent(_, data) {
      var recipientButtonName = data.detail.recipientButtonName;
      if (recipientButtonName !== this.name) return;
      this.isDisabled(false);
      this.buttonText(this.idleText);
      this.isLoading(false);
    }
  }, {
    key: "setupEvents",
    value: function setupEvents() {
      Kobo._mediator.register('kobo-loading-submit-button::loading');

      Kobo._mediator.subscribe('kobo-loading-submit-button::loading', this.handleLoadingEvent.bind(this));

      Kobo._mediator.register('kobo-loading-submit-button::loaded');

      Kobo._mediator.subscribe('kobo-loading-submit-button::loaded', this.handleLoadedEvent.bind(this));
    }
  }]);

  return LoadingSubmitButton;
}();